const md5 = require('md5');

/**
 * Crea una cadena de texto base 36 de longitud variable
 * @param {Integer} longitud 
 * @returns 
 */
export function generateCorrelativeHash() {
    return md5(crypto.randomUUID());
};
